<template>
  <span
    class="inline-block"
    :class="[
      sizeClasses[size],
      'rounded-sm overflow-hidden',
    ]"
    v-html="flagSvg"
  />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import type { PropType } from 'vue'
import { hasFlag } from 'country-flag-icons'
import * as countryFlags from 'country-flag-icons/string/3x2'

type FlagSize = 'xs' | 'sm' | 'md' | 'lg'

export default defineComponent({
  name: 'AM3FlagIcon',

  props: {
    flag: {
      type: String,
      required: true,
      validator: (value: string) => {
        if (!value) return false
        return value.length === 2 && hasFlag(value.toUpperCase())
      },
    },
    size: {
      type: String as PropType<FlagSize>,
      default: 'md',
      validator: (value: string) => ['xs', 'sm', 'md', 'lg'].includes(value),
    },
  },

  setup(props) {
    const sizeClasses = {
      xs: 'w-4 h-3 inline-flex flex-shrink-0',
      sm: 'w-6 h-4 inline-flex flex-shrink-0',
      md: 'w-8 h-6 inline-flex flex-shrink-0',
      lg: 'w-10 h-8 inline-flex flex-shrink-0',
    }

    const flagSvg = computed(() => {
      if (!props.flag) return ''
      const countryCode = props.flag?.toUpperCase()
      try {
        return countryFlags[countryCode as keyof typeof countryFlags] || ''
      }
      catch (error) {
        console.warn(`Flag not found: ${countryCode}`)
        return ''
      }
    })

    return {
      sizeClasses,
      flagSvg,
    }
  },
})
</script>
